import { render, staticRenderFns } from "./SlidePage.vue?vue&type=template&id=1aae04e6"
import script from "./SlidePage.vue?vue&type=script&lang=js"
export * from "./SlidePage.vue?vue&type=script&lang=js"
import style0 from "./SlidePage.vue?vue&type=style&index=0&id=1aae04e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports